import { create } from "zustand";

const useSupplyStore = create((set) => ({
  supplies: [],
  addSupply: (supply) =>
    set((state) => ({ supplies: [...state.supplies, supply] })),
  removeSupply: (id) =>
    set((state) => ({ supplies: state.supplies.filter((s) => s.id !== id) })),
  clearSupplies: () => set({ supplies: [] }),
}));

export default useSupplyStore;
